import { Component, createEffect, Show } from "solid-js";
import { H1Styled, StyledModal } from "./style";
import { useI18n } from "@solid-primitives/i18n";
import { appState } from "../../../../config/app.state";
import { isMobile, updateIsMobile } from "../../../hooks/isMobile";
import {
  MobileConnectionModal,
} from "./mobile-connection-modal";
import { Dynamic } from "solid-js/web";
import {
  DesktopConnectionModal,
} from "./desktop-connection-modal";
import { WalletInfoRemoteWithOpenMethod, WalletInfoWithOpenMethod, WalletOpenMethod, WalletsModalCloseReason } from "../../../../models";
import LoadingModalPage from "./layout/LoadingModalPage";
import {EngineConnectInfo, WalletInfoRemote} from "@okxconnect/core";

export interface SingleWalletModalProps {
  opened: boolean;
  walletInfo: WalletInfoRemote | null;
  loadingBeforeConnect: () => boolean;
  universalLinkParams: () => EngineConnectInfo | null
  connect: () => any;
  onClose: (closeReason: WalletsModalCloseReason) => void;
  isSingleWallet: boolean;
  lastSelectedWalletInfo: WalletInfoRemoteWithOpenMethod | {
    openMethod: WalletOpenMethod;
  } | null;
  setLastSelectedWalletInfo(walletInfo: WalletInfoWithOpenMethod | {
    openMethod: WalletOpenMethod;
} | null): void;
}

export const SingleWalletModal: Component<SingleWalletModalProps> = (props) => {
  const { locale } = useI18n()[1];
  createEffect(() => locale(appState.language));

  createEffect(() => {
    if (props.opened) {
      updateIsMobile();
    }
  });

  return (
    <StyledModal
      opened={props.opened}
      onClose={() => props.onClose("action-cancelled")}
      data-tc-wallets-modal-container="true"
    >
      <Show when={props.loadingBeforeConnect()}>
        <H1Styled>{props.walletInfo?.name}</H1Styled>
        <LoadingModalPage />
      </Show>

      <Show when={!props.loadingBeforeConnect()}>
        <Dynamic
          component={
            isMobile() ? MobileConnectionModal : DesktopConnectionModal
          }
          wallet={props.walletInfo!} // TODO: remove non-null assertion
          onBackClick={() => {}}
          backDisabled={true}
          connect={props.connect}
          isSingleWallet={props.isSingleWallet}
          universalLinkParams = {props.universalLinkParams}
          lastSelectedWalletInfo={props.lastSelectedWalletInfo}
          setLastSelectedWalletInfo={props.setLastSelectedWalletInfo}
        />
      </Show>
    </StyledModal>
  );
};
